<template>
    <div class="container">
        <vue-headful
                title="Testimonials - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-5">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="col">
                                <h3>Testimonials</h3>
<!--                                <div class="row">-->
<!--                                    <div class="m-2" @click="get_Testimonials('companies')">-->
<!--                                        <base-button>Companies</base-button>-->
<!--                                    </div>-->
<!--                                    <div class="m-2" @click="get_Testimonials('students')">-->
<!--                                        <base-button>Universities</base-button>-->
<!--                                    </div>-->
<!--                                    <div class="m-2" @click="wip()">-->
<!--                                        <base-button>Previous SIC Members</base-button>-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>
                            <div class="col text-right">
                                <router-link :to="{name: 'website-testimonials-add'}" class="btn my-4 btn-primary">
                                    ADD Testimonials
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th>Actions</th>
                                <th scope="col">User ID</th>
                                <th scope="col">User Type</th>
                                <th scope="col">Testimonials</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="testi in testimonialsDetails" :key="testi.id">
                                <td>
                                    <button @click="deleteTesti(testi.id)" type="button"
                                            class="btn btn-danger fas fa-trash" data-toggle="tooltip"
                                            data-placement="top" title="Delete Testimonial"></button>
                                    <router-link :to="{name: 'website-testimonials-update', params: { testimonial_id: testi.id }}" class="btn btn-info fas fa-pen"
                                            data-toggle="tooltip" data-placement="top" title="Edit Testimonial"></router-link>
                                </td>
                                <td scope="row">
                                    <strong>{{testi.user_id}}</strong>
                                </td>
                                <td v-html="getUserType(testi.user_type)">
                                </td>
                                <td v-html="testi.testimonial">
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import axios from "axios";
import vueHeadful from "vue-headful";

export default {
  data() {
    return {
      testimonialsDetails: {}
    };
  },
  methods: {
    wip: function() {
      alert("Work in progress");
    },
    get_Testimonials() {
      axios({
        url:
          "admin/testimonials/all" +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.testimonialsDetails = result.data.testimonials;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    deleteTesti(id) {
      axios({
        method: "delete",
        url: "admin/testimonials/delete/" + id,
        data: {
          access_token: localStorage.getItem("access_token")
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal("Testimonials Deleted Successfully", "", "success");
            this.get_Testimonials();
            result;
          },
          error => {
            this.$swal(
              "Error",
              "There was an error. Please try again",
              "error"
            );
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    getUserType(type) {
      if (type == "1") {
        return "<span class='text-success'>Student</span>";
      } else if (type == "2") {
        return "<span class='text-info'>Company</span>";
      } else {
        return "<span class='text-primary'>Employee</span>";
      }
    }
  },
  computed: {},
  components: {
    "vue-headful": vueHeadful
  },
  mounted: function() {
    this.get_Testimonials();
  }
};
</script>
<style>
</style>
